(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('custom-text-faq')) {
    customElements.define('custom-text-faq', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        const content = this.querySelector('[data-faq-content]');
        if (!content) return;
        this.initialized = true;
        const nodes = Array.from(content.childNodes);
        if (!nodes.some(node => node.nodeType === 1 && node.tagName === 'H2')) return;

        const fragment = document.createDocumentFragment();
        const entries = [];
        let answer = null;
        nodes.forEach(node => {
          if (node.nodeType === 1 && node.tagName === 'H2') {
            const item = document.createElement('div');
            item.className = 'custom-text-faq__item';
            const question = document.createElement('h2');
            question.className = 'custom-text-faq__question';
            if (node.id) question.id = node.id;
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'custom-text-faq__button';
            const label = document.createElement('span');
            label.textContent = node.textContent.trim();
            const icon = document.createElement('span');
            icon.className = 'custom-text-faq__icon';
            icon.setAttribute('aria-hidden', 'true');
            button.append(label, icon);
            question.append(button);
            answer = document.createElement('div');
            answer.className = 'custom-text-faq__answer';
            answer.id = this.id + '-answer-' + (entries.length + 1);
            button.setAttribute('aria-controls', answer.id);
            const entry = { button, answer };
            entries.push(entry);
            this.setOpen(entry, this.dataset.first === 'true' && entries.length === 1);
            button.addEventListener('click', () => {
              const opening = button.getAttribute('aria-expanded') !== 'true';
              if (opening && this.dataset.single === 'true') {
                entries.forEach(other => this.setOpen(other, false));
              }
              this.setOpen(entry, opening);
            });
            item.append(question, answer);
            fragment.append(item);
          } else if (answer) {
            answer.append(node);
          } else {
            fragment.append(node);
          }
        });
        content.replaceChildren(fragment);
      }
      setOpen(entry, open) {
        entry.button.setAttribute('aria-expanded', String(open));
        entry.answer.hidden = !open;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
